import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useCollection } from "../../../../hooks/useCollection";
import ResourcesNavbar from "./ResourcesNavbar";
import ResourcesTable from "./ResourcesTable";

export default function AdminResourcesDetails() {
  const { document } = useCollection("resources");

  return (
    <div className="relative w-full py-20 mx-4">
      <div className="relative max-w-5xl mx-auto bg-white p-4 md:p-10 rounded-md z-10">
        <div className="pb-6 flex justify-between">
          <h2 className="font-bold text-xl">Resources</h2>
          <Link to="/admin/add-resource">
            <div className="flex items-center gap-2 cursor-pointer">
              <FaPlus />
              <p>Add New</p>
            </div>
          </Link>
        </div>
        <div className="p-4">
          <ResourcesNavbar />
          <ResourcesTable resources={document} />
        </div>
      </div>
    </div>
  );
}
